// CMS styles here
import _ from 'lodash'

const cmsColors = getColors => `
    .cms-text-primary {
      color: ${_.get(getColors, 'primary_color')} !important;
    }
    .cms-text-primary-light {
      color: ${_.get(getColors, 'primary_color_light')} !important;
    }
    .cms-text-secondary {
      color: ${_.get(getColors, 'secondary_color')} !important;
    }
    .cms-text-warning {
      color: ${_.get(getColors, 'warning_color')} !important;
    }
    .cms-text-danger {
      color: ${_.get(getColors, 'danger_color')} !important;
    }
    .cms-text-muted {
      color: ${_.get(getColors, 'muted_color')} !important;
    }
    .cms-text-muted-secondary {
      color: ${_.get(getColors, 'muted_color_secondary')} !important;
    }


    .cms-bg-color-primary {
      background-color: ${_.get(getColors, 'primary_color')}  !important;
    }
    .cms-bg-color-primary-light {
      background-color: ${_.get(getColors, 'primary_color_light')}  !important;
    }
    .cms-bg-color-secondary {
      background-color: ${_.get(getColors, 'secondary_color')} !important;
    }
    .cms-bg-color-light {
      background-color: ${_.get(getColors, 'light_color')} !important;
    }
    .cms-bg-color-warning {
      background-color: ${_.get(getColors, 'warning_color')} !important;
    }
    .cms-bg-color-danger {
      background-color: ${_.get(getColors, 'danger_color')} !important;
    }
    .cms-bg-color-muted {
      background-color: ${_.get(getColors, 'muted_color')} !important;
    }
    .cms-bg-color-muted-secondary {
      background-color: ${_.get(getColors, 'muted_color_secondary')} !important;
    }
    .cms-bg-color-light {
      background-color: ${_.get(getColors, 'light_color')} !important;
    }

    .cms-outline-primary {
      border-color: ${_.get(getColors, 'primary_color')}  !important;
    }
    .cms-outline-primary-light {
      border-color: ${_.get(getColors, 'primary_color_light')}  !important;
    }
    .cms-outline-secondary {
      border-color: ${_.get(getColors, 'secondary_color')} !important;
    }
    .cms-outline-warning {
      border-color: ${_.get(getColors, 'warning_color')} !important;
    }
    .cms-outline-danger {
      border-color: ${_.get(getColors, 'danger_color')} !important;
    }
    .cms-outline-muted {
      border-color: ${_.get(getColors, 'muted_color')} !important;
    }
    .cms-outline-muted-secondary {
      border-color: ${_.get(getColors, 'muted_color_secondary')} !important;
    }
  `

  export default cmsColors;
